<app-progress-bar />
<router-outlet />
<app-cookie-consent-banner />